export default __webpack_public_path__ + "static/media/Angat_Logo.75d7a2ba.png";